// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__YyFph","primary":"Button_primary__ToyYA","secondary":"Button_secondary__fkM_f","transparent":"Button_transparent__K3kBA"};